'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CreditCard = require('./CreditCard');

var _CreditCard2 = _interopRequireDefault(_CreditCard);

var _stripeService = require('./stripeService');

require('./CreditCard.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreditCardForm = function (_React$Component) {
    _inherits(CreditCardForm, _React$Component);

    function CreditCardForm() {
        _classCallCheck(this, CreditCardForm);

        return _possibleConstructorReturn(this, (CreditCardForm.__proto__ || Object.getPrototypeOf(CreditCardForm)).apply(this, arguments));
    }

    _createClass(CreditCardForm, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            (0, _stripeService.bootStripe)();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'CreditCardForm' },
                _react2.default.createElement(_CreditCard2.default, this.props)
            );
        }
    }]);

    return CreditCardForm;
}(_react2.default.Component);

exports.default = CreditCardForm;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/creditCard/CreditCardContainer.js
// module id = 699
// module chunks = 0